var rellax = new Rellax(".rellax", {
	breakpoints: [0, 768, 1024],
});

jQuery(function ($) {
	$(window).scroll(function () {
		setTopBarBackground();
	});

	$(document).ready(function () {
		setTopBarBackground();
		makeMegaMenu();
		footerMenuToggle();
		scrollOnPageLoad();
		backToTopScroller();

		// Close off-canvas menu when anchor link is clicked
		$("#off-canvas .close-on-click a").on("click", function (e) {
			console.log(this.pathname, window.location.pathname);
			if (this.pathname === window.location.pathname) {
				e.preventDefault;
				let dest = $(this.hash);

				$("#off-canvas").foundation("close");

				if (Foundation.MediaQuery.is("tablet down")) {
					jQuery("html, body").animate(
						{
							scrollTop: dest.offset().top - 40,
						},
						1000
					);
				} else {
					jQuery("html, body").animate(
						{
							scrollTop: dest.offset().top - 130,
						},
						1000
					);
				}
			}
		});

		$(".has-fixed-icon").each(function () {
			ScrollTrigger.create({
				trigger: this,
				start: "top 20%",
				// end: "bottom top",
				onEnter: () => {
					var $el = $(this);
					$el.append('<span class="fixed-icon"></span>');
					// $el.addClass("display");
					// setTimeout(function () {
					// 	$el.addClass("opacity");
					// }, 10);
				},
				onLeave: () => {
					var $el = $(this);
					$el.find(".fixed-icon").remove();
					// $el.removeClass("opacity");
					// setTimeout(function () {
					// 	$el.removeClass("display");
					// 	setTimeout(function () {
					// 		$el.find(".fixed-icon").remove();
					// 	}, 10);
					// }, 1200);
				},
				onEnterBack: () => {
					var $el = $(this);
					$el.append('<span class="fixed-icon"></span>');
					// $el.addClass("display");
					// setTimeout(function () {
					// 	$el.addClass("opacity");
					// }, 10);
				},
				onLeaveBack: () => {
					var $el = $(this);
					$el.find(".fixed-icon").remove();
					// $el.removeClass("opacity");
					// setTimeout(function () {
					// 	$el.removeClass("display");
					// 	setTimeout(function () {
					// 		$el.find(".fixed-icon").remove();
					// 	}, 10);
					// }, 1200);
				},
			});
		});

		// ScrollTrigger.create({
		// 	trigger: "#contact",
		// 	start: "top 60%",
		// 	//end: "top bottom",
		// 	onEnter: () => {
		// 		$("#contact").addClass("display");
		// 		setTimeout(function () {
		// 			$("#contact").addClass("opacity");
		// 		}, 100);
		// 	},
		// 	onLeaveBack: () => {
		// 		$("#contact").removeClass("opacity");
		// 		setTimeout(function () {
		// 			$("#contact").removeClass("display");
		// 		}, 2000);
		// 	},
		// });

		$(".animate").each(function () {
			ScrollTrigger.create({
				trigger: this,
				start: "top bottom",
				end: "bottom top",
				onEnter: () => $(this).addClass("animated"),
				onLeave: () => {
					if (
						!$(this).hasClass("animate-once") &&
						!$(this).hasClass("animate-down-only")
					) {
						$(this).removeClass("animated");
					}
				},
				onEnterBack: () => $(this).addClass("animated"),
				onLeaveBack: () => {
					if (!$(this).hasClass("animate-once")) {
						$(this).removeClass("animated");
					}
				},
			});
		});
	});

	$(window).resize(function () {
		makeMegaMenu();
		footerMenuToggle();
	});
});

function backToTopScroller() {
	jQuery(".to-top").on("click", function (e) {
		e.preventDefault();
		jQuery("html, body").animate(
			{
				scrollTop: 0,
			},
			1000
		);
		history.replaceState(null, '', ' ');
	});

	ScrollTrigger.create({
		trigger: jQuery(".off-canvas-content"),
		start: "top -200px",
		end: "bottom bottom",
		onEnter: () => jQuery(".to-top").addClass("show"),
		onLeave: () => jQuery(".to-top").removeClass("show"),
		onEnterBack: () => jQuery(".to-top").addClass("show"),
		onLeaveBack: () => jQuery(".to-top").removeClass("show"),
	});
}

function scrollOnPageLoad() {
	// to top right away
	if (window.location.hash) scroll(0, 0);
	// void some browsers issue
	setTimeout(scroll(0, 0), 1);
	var hashLink = window.location.hash;
	if (jQuery(hashLink).length) {
		jQuery(function () {
			// *only* if we have anchor on the url
			// smooth scroll to the anchor id
			if (Foundation.MediaQuery.is("tablet down")) {
				jQuery("html, body").animate(
					{
						scrollTop: jQuery(window.location.hash).offset().top - 40,
					},
					1000
				);
			} else {
				jQuery("html, body").animate(
					{
						scrollTop: jQuery(window.location.hash).offset().top - 130,
					},
					1000
				);
			}
		});
	}
}

function setTopBarBackground() {
	var header = jQuery("header .top-bar");
	var scroll = jQuery(window).scrollTop();

	if (Foundation.MediaQuery.is("large") && scroll >= 50) {
		header.addClass("dark");
	} else {
		header.removeClass("dark");
	}
}

// function changeOffCanvasTransition() {
// 	var method = jQuery(".off-canvas").data("transition");
// 	var reload = false;
//
// 	if (Foundation.MediaQuery.is("tablet down")) {
// 		if (method != "push") {
// 			jQuery(".off-canvas")
// 				.attr("data-transition", "push")
// 				.data("transition", "push")
// 				.toggleClass("is-transition-push is-transition-overlay");
// 			reload = true;
// 		}
// 	} else {
// 		if (method != "overlay") {
// 			jQuery(".off-canvas")
// 				.attr("data-transition", "overlay")
// 				.data("transition", "overlay")
// 				.toggleClass("is-transition-push is-transition-overlay");
// 			reload = true;
// 		}
// 	}
//
// 	if (reload) {
// 		jQuery("#off-canvas").foundation("_destroy");
// 		var elem = new Foundation.OffCanvas(jQuery("#off-canvas"));
// 	}
// }

function makeMegaMenu() {
	var hasColumns = jQuery("#offcanvas-nav > li.column").length;

	if (Foundation.MediaQuery.atLeast("large")) {
		if (hasColumns === 0) {
			jQuery("#offcanvas-nav > li")
				.slice(0, 3)
				.wrapAll('<li class="column"><ul></ul></li>');
			jQuery("#offcanvas-nav > li")
				.slice(1)
				.wrapAll('<li class="column"><ul></ul></li>');
		}
	} else {
		if (hasColumns > 0) {
			jQuery("#offcanvas-nav > li.column > ul > li").unwrap().unwrap();
		}
	}
}

function footerMenuToggle() {
	var isDropdown = jQuery("#footer-links > li.mobile-toggle").length;
	var reload = false;

	if (Foundation.MediaQuery.is("tablet down")) {
		if (isDropdown === 0) {
			jQuery("#footer-links")
				.attr("data-dropdown-menu", "")
				.attr("data-click-open", "true");
			jQuery("#footer-links > li").wrapAll(
				'<li class="mobile-toggle"><ul class="menu"></ul></li>'
			);
			jQuery("#footer-links .mobile-toggle").prepend(
				'<a href="#" onClick="return false;"><i class="fa-solid fa-bars"></i> Menu</a>'
			);
			var elem = new Foundation.DropdownMenu(jQuery("#footer-links"));
		}
	} else {
		if (isDropdown > 0) {
			jQuery("#footer-links").removeAttr("data-dropdown-menu data-click-open");
			jQuery("#footer-links .mobile-toggle > a").remove();
			jQuery("#footer-links > li.mobile-toggle > ul > li").unwrap().unwrap();
			jQuery("#footer-links").foundation("_destroy");
		}
	}
}

/* Light YouTube Embeds by @labnol */
/* Web: http://labnol.org/?p=27941 */
function initYouTubeVideos() {
	var playerElements = document.getElementsByClassName("youtube-player");
	for (var n = 0; n < playerElements.length; n++) {
		var videoId = playerElements[n].dataset.id;
		var div = document.createElement("div");
		div.setAttribute("data-id", videoId);
		var thumbNode = document.createElement("img");
		thumbNode.src = "//i.ytimg.com/vi/ID/hqdefault.jpg".replace("ID", videoId);
		div.appendChild(thumbNode);
		var playButton = document.createElement("div");
		playButton.setAttribute("class", "play");
		div.appendChild(playButton);
		div.onclick = function () {
			labnolIframe(this);
		};
		playerElements[n].appendChild(div);
	}
}

function labnolIframe(div) {
	var iframe = document.createElement("iframe");
	iframe.setAttribute(
		"src",
		"https://www.youtube.com/embed/" +
			div.dataset.id +
			"?autoplay=1&rel=0&enablejsapi=1"
	);
	iframe.setAttribute("frameborder", "0");
	iframe.setAttribute("allowfullscreen", "1");
	iframe.setAttribute(
		"allow",
		"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
	);
	div.parentNode.replaceChild(iframe, div);
}

document.addEventListener("DOMContentLoaded", initYouTubeVideos);

// Stops iframe videos in reveal window from playing on reveal window close
jQuery(document).on("closed.zf.reveal", "[data-reveal]", function () {
	var id = this.id;
	var isYt = jQuery("#" + id + " .video__wrapper > div").hasClass(
		"youtube-player"
	)
		? true
		: false;
	var iframe = jQuery("#" + id + " iframe");
	var vid = jQuery("#" + id + " video");

	if (iframe.length > 0) {
		if (isYt) {
			jQuery(iframe).each(function () {
				this.contentWindow.postMessage(
					'{"event":"command","func":"pauseVideo","args":""}',
					"*"
				);
			});
		} else {
			jQuery(iframe).each(function () {
				var src = this.src;
				this.src = "";
				this.src = src;
			});
		}
	} else if (vid.length > 0) {
		jQuery(vid).trigger("pause");
	}
});
